import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { discoveryApiRef, fetchApiRef, googleAuthApiRef } from '@backstage/core-plugin-api';
import { ChangeManagementClient, changeManagementApiRef } from './api';
import { rotaRaiz } from './rotas';

// Montagem no novo sistema de frontend, que é o que o portal usa.
//
// As quatro telas ficam sob a mesma PageBlueprint e o roteamento interno é
// resolvido pelo React Router: são páginas de um fluxo só (calendário → nova
// mudança → relatórios → admin), e registrá-las como extensões separadas
// espalharia quatro itens no menu para uma funcionalidade só.

const apiExtensao = ApiBlueprint.make({
  name: 'change-management-api',
  params: defineParams =>
    defineParams({
      api: changeManagementApiRef,
      // `googleAuth` é o que permite o convite nascer na agenda de quem agenda,
      // em vez de exigir uma service account liberada no Admin do Workspace.
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        googleAuth: googleAuthApiRef,
      },
      factory: ({ discoveryApi, fetchApi, googleAuth }) =>
        new ChangeManagementClient({ discoveryApi, fetchApi, googleAuth }),
    }),
});

const paginaExtensao = PageBlueprint.make({
  name: 'change-management',
  params: {
    path: '/change-calendar',
    routeRef: rotaRaiz,
    loader: async () => {
      const { RoteadorChangeManagement } = await import('./Roteador');
      return <RoteadorChangeManagement />;
    },
  },
});

// O item de menu "Mudanças" não é registrado aqui: ele é renderizado
// explicitamente no Sidebar do app (packages/app/src/modules/nav/Sidebar.tsx),
// numa posição fixa do menu, como o Value Stream e o Q&A.

// Tipo anotado à mão: sem isso o tsc tenta nomear o tipo inferido e esbarra
// numa cópia aninhada de @backstage/core-plugin-api que não é referenciável.
const changeManagementPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'change-management',
  extensions: [apiExtensao, paginaExtensao],
});

export default changeManagementPlugin;
